import useFunnelNavigation from '@/hooks/useFunnelNavigation';
import { getBrand } from '@/utils/getBrand';

const GoToCheckoutButton = ({ className = '', ...props }) => {
  const { navigateToCheckout } = useFunnelNavigation();
  const { brandName } = getBrand();

  return (
    <button
      onClick={() => navigateToCheckout(null, { funnelId: 28 })}
      className={`bg-[#EFEFEF] font-semibold rounded-2xl flex items-center justify-center gap-2 px-6 py-4 hover:bg-[#E5E5E5] transition-colors ${className}`}
      {...props}
    >
      Get started with {brandName}
    </button>
  );
};

export default GoToCheckoutButton;
